<template>
    <div style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <div class="settings-container">
                <!-- Back Button -->
                <CRow class="header-row mb-3 position-relative">
                    <!-- Back Button on the Left -->
                    <CCol class="col-auto">
                        <CButton class="back-button" @click="$router.go(-1)">
                            ←
                        </CButton>
    
                    </CCol>
    
                    <!-- Centered Title -->
                    <CCol class="d-flex justify-content-center position-absolute start-50 translate-middle-x">
                        <h3 class="section-title m-0">Setting</h3>
                    </CCol>
                </CRow>
                <div class="flex flex-col items-center text-center">
                    <br /><br />
                    <!-- Profile Image with Edit Button -->
                    <div class="profile-container">
                        <span>
                                                                                      <img v-if="filePath == ''" width="100px" src="../assets/img/DefaultUser.png" class="avatar-img"/>
                                                                                      <img v-else width="100px" :src="filePath" style="border-radius: 50%; border: 5px solid #fff" class="avatar-img"/>
                                                                                      <img src="../assets/img/edit.png" class="edit-img" style="max-width:30px" @click="triggerFileInput"/>
                                                                                      <input type="file" ref="fileInput" @change="onFileChange" style="display: none;"/>
                                                                                    </span>
                    </div>
                    <!-- Upload Text -->
                    <h3 class="mt-3 text-lg font-semibold custom-14px-500">Upload Profile Photo</h3>
                    <h4 class="text-sm text-gray-500 font-color-8C8C8C custom-12px-400">Upload Profile Photo PNG, JPG <br> Max 10mb.</h4>
                </div>
    
                <CCol sm="12">
                    <div class="text-left">
                        <h4 class="custom-14px-400">Full Name</h4>
                        <CInput type="text" v-model="FullName"/>
    
                        <h4 class="custom-14px-400">Email</h4>
                        <CInput type="text" v-model="Email" disabled/>
    
                        <h4 class="custom-14px-400">Phone Number</h4>
                        <CInput type="text" v-model="PhoneNumber"/>
                    </div>
    
    
                </CCol>
    
            </div>
            <CCol sm="12" class="fixed-bottom-button d-flex justify-content-center">
                <CButton class="custom-border-purple update-btn" color="primary" block @click="UpdateProfile()">
                    Update
                </CButton>
            </CCol>

            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Save Successfully
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
    
        </CContainer>
    </div>
</template>
  
<script>
import Mainlayout from "../containers/AllHeader.vue";

export default {
    components: {
        Mainlayout
    },
    data() {
        return {
            profileImage: require("@/assets/img/new/userprofile.png"), // Default profile image
            filePath: "",

            FullName: "",
            PhoneNumber: "",
            isPopupSuccess:false
        };

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.GetInfoUser();
                this.GetListCountries();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            GoToLogin
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        uploadImage(event) {
            const file = event.target.files[0];
            if (file) {
                this.profileImage = URL.createObjectURL(file);
            }
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file; // Store the selected file
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.filePath = e.target.result;
                };
                reader.readAsDataURL(file);

                // Auto-submit the form after file selection
                this.submitProfilePicture();
            }
        },
        async submitProfilePicture() {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('userId', this.UserId);

                try {
                    const response = await this.$API
                        .post(this.$UploadProfilePhoto, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                    console.log('Image uploaded successfully:', response.data);
                    this.isPopupSuccess = true;
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            } else {
                console.log('No file selected');
            }
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.Name = this.info.name;
                        this.FullName = this.info.name;
                        this.PhoneNumber = this.info.phone;
                        this.Email = this.info.email;
                        this.CountryName = this.info.country;
                        this.UserType = this.info.userType;
                        this.AboutUsCandidate = this.info.aboutUsCandidate;
                        this.UserId = this.info.id;
                        this.GetListCountries();
                        this.SetupSelectedOption(this.CountryName);
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        UpdateProfile() {
            const formData = new FormData();

            formData.append("fullName", this.FullName);
            formData.append("phoneNumber", this.PhoneNumber);

            this.$API
                .post(this.$UserDetails, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                         
                            this.isPopupSuccess = true;
                            this.GetInfoUser();
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
    }
};
</script>
  
<style scoped>
label:hover {
    background-color: #7c3aed;
    /* Darker purple */
}

.profile-container {
    position: relative;
    display: inline-block;
}

.avatar-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 5px solid #fff;
    object-fit: cover;
    display: block;
}

.edit-btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.edit-img {
    width: 20px;
    height: 20px;
}

.hidden-input {
    display: none;
}

.position-bottom {
    position: fixed;
    bottom: 20px;
    width: 96%;
    z-index: 1000;
    text-align: center;
    padding: 10px;
}
</style>